import { render, staticRenderFns } from "./ThisFooter.vue?vue&type=template&id=4df7995c&scoped=true"
var script = {}
import style0 from "./ThisFooter.vue?vue&type=style&index=0&id=4df7995c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7995c",
  null
  
)

export default component.exports